export const filterDefined = <T>(list: (T | null | undefined)[]): T[] =>
  list.filter((it) => !!it) as T[];
